<template>
    <div class="listView">
        <div class="searchRange">
            <div class="range-item" @click="setSearchRange('all')" :class="[currentRange==='all' ? 'active' : '']">全部</div>
            <div class="range-item" @click="setSearchRange('book')" :class="[currentRange==='book' ? 'active' : '']">文献</div>
            <!-- <div class="range-item" @click="setSearchRange('paper')" :class="[currentRange==='paper' ? 'active' : '']">报纸</div> -->
        </div>
        <div class="list">
            <div v-for="(item, index) of records" :key="index" class="item" @click="goToPage(item)">
                <div class="title">{{item.title}}</div>
                <div class="description">{{item.description}}</div>
                <div class="infos">
                    <span>关键词： {{item.paramLst['关键词']}}</span>
                    <span style="margin-left: 20px;">来源: {{item.paramLst['所属单位']}}</span>
                </div>
            </div>
        </div>
        <el-pagination
            class="pagination"
            show-quick-jumper
            :default-current="pageIndex"
            :current-page.sync="pageIndex"
            :page-size.sync="pageSize"
            :total="total"
            layout="prev, pager, next, total"
            :show-total="(total) => `${total}`"
            @current-change="changePage"
        />
    </div>
</template>

<script>
import bookApi from '@/api/book';
import { getQueryString } from '@/utils'

export default {
    data () {
        return {
            currentRange: 'all',
            records: [],
            pageIndex: 1,
            pageSize: 20,
            searchValue: '',
            total: 0
        }
    },
    mounted () {
        // this.getData();
        this.schemaType = getQueryString('schemaType') ? getQueryString('schemaType') : 'all';
        this.keyWord = getQueryString('keyWord') ? getQueryString('keyWord') : '';
        this.classification = getQueryString('classification') ? getQueryString('classification') : '';
        this.bookName = getQueryString('bookName') ? getQueryString('bookName') : '';
        this.structureType = getQueryString('structureType') ? getQueryString('structureType') : '';
        this.getData();
    },
    methods: {
        setSearchRange (range) {
            this.currentRange = range;
            this.pageIndex = 1;
            this.getData();
        },
        getData () {
            let that = this;
            bookApi.getBook({
                path: 'getBookDataWithPrs',
                pageIndex: this.pageIndex,
                keyWord: this.keyWord,
                pageSize: this.pageSize,
                bookType: 'book',
                // bookType: this.currentRange === 'all' ? '' : this.currentRange,
                schemaType: this.schemaType,
                // schemaType: this.currentBookType.key,
                classification: this.classification,
                bookName: this.bookName,
                structureType: this.structureType,
                libraryCode: this.global.getLibraryInfos().code
            })
            .then((response) => {
                console.log(response);
                if (response.code === 200) {
                    that.total = response.data.count;
                    that.records = response.data.rows;
                }
            });
        },
        changePage (index) {
            this.pageIndex = index;
            this.getData();
        },
        goToPage (item) {
            if (item.schemaType === 'base') {
                let routeData = this.$router.resolve({
                path: '/bookDetail',
                    query: {
                        bookId: item.sourceID,
                        bookType: 'book',
                        schemaType: item.schemaType
                    }
                });

                // 必要操作，否则不会打开新页面
                window.open(routeData.href, '_blank');
            } else {
                let routeData = this.$router.resolve({
                path: '/schemaDetail',
                    query: {
                        identifier: item.identifier,
                        bookType: 'book',
                        schemaType: item.schemaType
                    }
                });

                // 必要操作，否则不会打开新页面
                window.open(routeData.href, '_blank');
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.listView {
    width: 60%;
    // height: 400px;
    background: white;
    border-radius: 5px;
    padding: 30 * @uh 0px 4px 40 * @uw;
    box-shadow: 0px 0px 10px 5px #e0e0e0;
    margin-bottom: 20px;

    .searchRange {
        width: 80%;
        // margin: 30 * @uh 0px 20 * @uh 40 * @uw;
        // padding-bottom: 5 * @uh;
        display: flex;
        border-bottom: 1px solid rgb(185, 185, 185);

        .range-item {
            font-size: 20 * @uw;
            margin-right: 20 * @uw;
            cursor: pointer;

            &.active {
                border-bottom: 2px solid #8d5e1a;
            }
        }
    }

    .list {
        margin-top: 30 * @uh;
        margin-right: 40 * @uw;

        .item {
            margin-bottom: 20 * @uh;
            padding-bottom: 20 * @uh;
            border-bottom: 1px solid rgb(228, 228, 228);
            .title {
                color: #0066cc;
                cursor: pointer;
                font-size: 20 * @uw;
            }

            .description {
                font-size: 14 * @uw;
                margin-top: 10 * @uh;
            }

            .infos {
                margin-top: 10 * @uh;
                font-size: 12 * @uw;
                color: rgb(148, 148, 148);
            }
        }
    }

    .pagination {
        margin-bottom: 10px;;
    }
}
</style>
